/* eslint-disable import/prefer-default-export */

import { displayRecaptcha, hideRecaptcha } from './'

export const dispatchDisplayRecaptcha = dispatch => dispatch(displayRecaptcha())

export const dispatchHideRecaptcha = dispatch => dispatch(hideRecaptcha())
